import { Model } from "./../Model"

export class ModelRelation{

	constructor( private classRef:typeof Model ){
	}

}
